module.exports = __webpack_public_path__ + "static/img/yinhang.6234c9a8.png";